// src/services/adminContenu.js
// Domaine Contenu — façade Worker Admin → Worker Contenu uniquement.
// Aucun appel direct au Worker Contenu depuis le navigateur.

import { apiFetch, buildQuery } from './adminHttp';

/* ---------- Contenus ---------- */

/** POST /admin/contenu/content — CONTENU_MODIFIER */
export async function createContent(payload) {
  return apiFetch('/admin/contenu/content', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

/** PATCH /admin/contenu/content/:id — CONTENU_MODIFIER */
export async function updateContent(id, payload) {
  return apiFetch(`/admin/contenu/content/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

/** POST /admin/contenu/content/:id/archive — CONTENU_MODIFIER */
export async function archiveContent(id) {
  return apiFetch(`/admin/contenu/content/${encodeURIComponent(id)}/archive`, {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

/* ---------- Catégories ---------- */

/** POST /admin/contenu/categories — CONTENU_CATEGORIES_MODIFIER */
export async function createCategory(payload) {
  return apiFetch('/admin/contenu/categories', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

/** PATCH /admin/contenu/categories/:id — CONTENU_CATEGORIES_MODIFIER */
export async function updateCategory(id, payload) {
  return apiFetch(`/admin/contenu/categories/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

/** POST /admin/contenu/categories/:id/deactivate — soft-delete */
export async function deactivateCategory(id) {
  return apiFetch(`/admin/contenu/categories/${encodeURIComponent(id)}/deactivate`, {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

/* ---------- Assets ---------- */

/** POST /admin/contenu/content/:content_id/assets — CONTENU_ASSETS_MODIFIER */
export async function createAsset(contentId, payload) {
  return apiFetch(`/admin/contenu/content/${encodeURIComponent(contentId)}/assets`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

/** PATCH /admin/contenu/assets/:id — CONTENU_ASSETS_MODIFIER */
export async function updateAsset(id, payload) {
  return apiFetch(`/admin/contenu/assets/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

/* ---------- Composants de formation ---------- */

/** POST /admin/contenu/content/:parent_id/components — CONTENU_COMPOSANTS_MODIFIER */
export async function createComponent(parentId, payload) {
  return apiFetch(`/admin/contenu/content/${encodeURIComponent(parentId)}/components`, {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

/** PATCH /admin/contenu/components/:id */
export async function updateComponent(id, payload) {
  return apiFetch(`/admin/contenu/components/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

/** POST /admin/contenu/components/:id/deactivate — soft-delete */
export async function deactivateComponent(id) {
  return apiFetch(`/admin/contenu/components/${encodeURIComponent(id)}/deactivate`, {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

/* ---------- Lecture ---------- */

/** GET /admin/contenu/stats — CONTENU_VOIR */
export async function getContenuStats() {
  return apiFetch('/admin/contenu/stats', { method: 'GET' });
}

/** GET /admin/contenu/audit — CONTENU_AUDIT_VOIR */
export async function getContenuAudit(params = {}) {
  return apiFetch(`/admin/contenu/audit${buildQuery(params)}`, { method: 'GET' });
}

/** GET /admin/contenu/origins — CONTENU_ORIGINES_VOIR (lecture seule) */
export async function getContenuOrigins() {
  return apiFetch('/admin/contenu/origins', { method: 'GET' });
}
